import {
  b2cIdealCustomerArray,
  b2cMotivateArray,
  customerIndustryArray,
  industryArray,
  sellingArray,
  sellingToArray,
} from "@/constants/Constants";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const btnText = (from: string = "") => {
  if (
    from === "/seller-industry" ||
    from === "/seller/selling-info" ||
    from === "/customer/selling-to" ||
    from === "/customer/industry" ||
    from === "/b2c/ideal-customer" ||
    from === "/b2c/motivates"
  ) {
    return "Continue";
  } else {
    return "";
  }
};

export const arr = (from: string = "") => {
  if (from === "/seller-industry") {
    return industryArray;
  } else if (from === "/seller/selling-info") {
    return sellingArray;
  } else if (from === "/customer/selling-to") {
    return sellingToArray;
  } else if (from === "/customer/industry") {
    return customerIndustryArray;
  } else if (from === "/b2c/ideal-customer") {
    return b2cIdealCustomerArray;
  } else if (from === "/b2c/motivates") {
    return b2cMotivateArray;
  } else {
    return [];
  }
};

export const secondaryHeading = (from: string = "") => {
  if (from === "/seller-industry") {
    return "Most Popular Industries";
  } else if (from === "/seller/selling-info") {
    return "Most Popular Products";
  } else if (from === "/customer/selling-to") {
    return "Popular consumer personas";
  } else if (from === "/customer/industry") {
    return "Most Popular Industries";
  } else if (from === "/b2c/ideal-customer") {
    return "Popular consumer personas";
  } else if (from === "/b2c/motivates") {
    return "Popular motivations & pain points";
  } else {
    return "";
  }
};

export const heading = (from: string = "") => {
  if (from === "/seller-industry") {
    return "What industry are you in?";
  } else if (from === "/seller/selling-info") {
    return "What are you selling?";
  } else if (from === "/customer/selling-to") {
    return "Who are you selling to?";
  } else if (from === "/customer/industry") {
    return "What industry are they in?";
  } else if (from === "/b2c/ideal-customer") {
    return "Who is your ideal customer?";
  } else if (from === "/b2c/motivates") {
    return "What motivates your buyer?";
  } else {
    return "";
  }
};

export const backLink = (from: string = "") => {
  if (from === "/seller-industry") {
    return "/";
  } else if (from === "/seller/selling-info") {
    return "/seller-industry";
  } else if (from === "/customer/selling-to") {
    return "/business-model";
  } else if (from === "/customer/industry") {
    return "/customer/selling-to";
  } else if (from === "/b2c/ideal-customer") {
    return "/business-model";
  } else if (from === "/b2c/motivates") {
    return "/b2c/buyer-persona";
  } else {
    return "";
  }
};

export function formatDateTimeTwoLines(isoDate: string): any {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return "";
  // Format date
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  // Format time
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12; // convert 0 to 12

  return {
    formattedDate: `${month}/${day}/${year}`,
    formattedTime: `${hours}:${minutes} ${ampm}`,
  };
}
